import { useEffect } from 'react'
import { useBrandingSettings } from './branding'

/**
 * Sets the document title.
 *
 * @param title
 */
export function useDocumentTitle(title?: string) {
  const { workspaceName } = useBrandingSettings()

  useEffect(() => {
    const suffix = workspaceName
    document.title = title ? `${title} — ${suffix}` : suffix
    return () => {
      document.title = suffix
    }
  }, [title, workspaceName])
}
